module.exports = __webpack_public_path__ + "img/iiot.6f6baf24.svg";